<template>
  <table class="table border-top-0 border-bottom table-striped">
    <thead>
      <tr>
        <th>SKU</th>
        <th>Description</th>
        <th>Case Qty</th>
        <th>Bottle Qty</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in order.items" :key="item.id">
        <td>{{ item.sku }}</td>
        <td>{{ item.description }}</td>
        <td>{{ item.case_qty }}</td>
        <td>{{ item.bottle_qty }}</td>
      </tr>
      <tr v-show="order.items.length == 0">
        <td colspan="4" class="text-center">No items for this order</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'items-tab',
  props: {
    order: Object,
  }
}
</script>